module.exports = __webpack_public_path__ + "static/media/adis.905bc5d1.jpg";